import React from 'react';

import cx from 'classnames';

import { UserMenu } from 'components/shared/Layout/shared';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './index.module.css';

function Wrapper(props) {
  const { children } = props;
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <>
      <div className={cx(s.wrapper)}>
        {children}

        {!isTabletOrMobile && (
          <div className={s.rightZone}>
            <div id="stuff" />
            <UserMenu />
          </div>
        )}
      </div>

      <div id="proposalSettingsMenu" style={{ zIndex: 10 }} />

      {isTabletOrMobile && <div id="stuff" />}
    </>
  );
}

export default Wrapper;
export { Wrapper };
